
const RadioButtonList = (props) => {
    return (
        <div>
            <span className='wtb-subtitle'>
                {props.label && <>{props.label}:</>}
                {props.required && <span className='required red'></span>}
            </span>
            <span className='red'>{props.validationErrors}</span>
            {props.options.map(item =>
                <div className={item.Checked ? props.class + ' active' : props.class} key={item.Value}>
                    <label>
                        <input type='radio' name={props.name} className='radio' value={item.Value} onChange={props.onFieldChanged} checked={props.value == item.Value} />
                        <span dangerouslySetInnerHTML={{ __html: item.Text }} ></span>
                    </label>
                </div>)}
        </div>
    );
};

export default RadioButtonList;